import store from '../store/store';

export const isAdmin = () => {
    if (!store.getState().login.logged) return false;
    const user = store.getState().login?.utente;

    return user?.ruolo === "Amministratore";
};
